export enum LawyerStatusKey {
  NOT_STARTED = 'not_started',
  MEETING_BOOKED = 'meeting_booked',
  COMPLETED = 'completed'
}